// Port de app/(tabs)/justificativas.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const JustificativasScreen = lazy(() => import("@/screens/Justificativas"));

export default function JustificativaRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <JustificativasScreen />
    </Carregando>
  ) : null;
}
